import { colors } from "./colors";

export const disabledContainedButtonStyles = {
  "&.Mui-disabled": {
    backgroundColor: `${colors.buttonDisabled.background} !important`,
    color: `${colors.buttonDisabled.color} !important`,
    opacity: 1,
    boxShadow: "none",
    cursor: "not-allowed",
  },
};

export const primaryContainedButtonSx = {
  backgroundColor: colors.primary,
  color: colors.white,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primaryHover,
    boxShadow: "none",
  },
  ...disabledContainedButtonStyles,
};
